// extracted by mini-css-extract-plugin
export var header = "_td-1";
export var maskBottom = "_td-6";
export var maskMiddle = "_td-7";
export var maskTop = "_td-5";
export var root = "_td-0";
export var scrollDownButton = "_td-3";
export var scrollDownButtonHidden = "_td-4";
export var viewport = "_td-2";